import React from "react";
import PieChart from "../piechart";

const Age = ({ HighchartsReact, Highcharts, data }) => {
  return (
    <>
      <PieChart
        title={"Age"}
        // data={[
        //   {
        //     name: "18 - 24yrs",
        //     y: 23,
        //   },
        //   {
        //     name: "25 - 34yrs",
        //     y: 56,
        //   },
        //   {
        //     name: "35 - 44yr",
        //     y: 36,
        //   },
        //   {
        //     name: "45 - 54yrs",
        //     y: 0,
        //   },
        //   {
        //     name: "55 - 64yrs",
        //     y: 5,
        //   },
        //   {
        //     name: "65+",
        //     y: 1,
        //   },
        // ]}
        data={data}
        Highcharts={Highcharts}
        HighchartsReact={HighchartsReact}
      />
    </>
  );
};

export default Age;
